import React, { lazy, Suspense } from 'react';
import { ToastViewport } from './components/ToastNotice';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import { authService } from './api/services';
import { LanguageProvider } from './contexts/LanguageContext';
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const RoomList = lazy(() => import('./pages/RoomList'));
const RoomDetail = lazy(() => import('./pages/RoomDetail'));
const CreateRoom = lazy(() => import('./pages/CreateRoom'));
const EditRoom = lazy(() => import('./pages/EditRoom'));
const MyRooms = lazy(() => import('./pages/MyRooms'));
const BookingList = lazy(() => import('./pages/BookingList'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const UserList = lazy(() => import('./pages/UserList'));
const Profile = lazy(() => import('./pages/Profile'));
const Projects = lazy(() => import('./pages/Projects'));
const SalerInventory = lazy(() => import('./pages/SalerInventory'));
const CreateDeposit = lazy(() => import('./pages/CreateDeposit'));
const WalletTopUp = lazy(() => import('./pages/WalletTopUp'));

const PrivateRoute = ({ children, roles = [] }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (roles.length > 0) {
    const user = authService.getCurrentUser();
    if (!roles.includes(user?.role)) {
      return <Navigate to="/" />;
    }
  }

  return children;
};

const GuestOnlyRoute = ({ children }) => {
  if (authService.isAuthenticated()) {
    return <Navigate to="/rooms" replace />;
  }

  return children;
};

const DepositEditor = () => {
  const location = useLocation();
  return <CreateDeposit key={location.search} />;
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <ToastViewport />
          <Navbar />
          <Suspense fallback={<p role="status">Đang tải trang…</p>}>
          <Routes>
          <Route path="/" element={<Navigate to="/rooms" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={
            <GuestOnlyRoute>
              <Login />
            </GuestOnlyRoute>
          } />
          <Route path="/register" element={
            <GuestOnlyRoute>
              <Register />
            </GuestOnlyRoute>
          } />
          <Route path="/rooms" element={<RoomList />} />
          <Route path="/rooms/:id" element={<RoomDetail />} />
          <Route path="/projects" element={<PrivateRoute roles={['admin', 'landlord']}><Projects /></PrivateRoute>} />
          <Route path="/inventory" element={<PrivateRoute roles={['saler']}><SalerInventory/></PrivateRoute>}/>
          <Route path="/projects/new" element={<PrivateRoute roles={['admin', 'landlord']}><Projects mode="new" /></PrivateRoute>} />
          <Route path="/projects/:projectId" element={<PrivateRoute roles={['admin', 'landlord']}><Projects mode="edit" /></PrivateRoute>} />
          
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          <Route path="/create-room" element={
            <PrivateRoute roles={['landlord', 'saler', 'admin']}>
              <CreateRoom />
            </PrivateRoute>
          } />
          
          <Route path="/edit-room/:id" element={
            <PrivateRoute roles={['landlord', 'saler', 'admin']}>
              <EditRoom />
            </PrivateRoute>
          } />
          
          <Route path="/my-rooms" element={
            <PrivateRoute roles={['landlord', 'saler', 'admin']}>
              <MyRooms />
            </PrivateRoute>
          } />
          <Route path="/expired-listings" element={<PrivateRoute roles={['landlord','saler','admin']}><MyRooms expiredMode /></PrivateRoute>} />
          <Route path="/admin/rooms" element={
            <PrivateRoute roles={['admin']}>
              <MyRooms adminMode />
            </PrivateRoute>
          } />
          
          <Route path="/bookings" element={
            <PrivateRoute>
              <BookingList />
            </PrivateRoute>
          } />

          <Route path="/create-deposit" element={
            <PrivateRoute>
              <DepositEditor />
            </PrivateRoute>
          } />
          <Route path="/wallet/top-up" element={
            <PrivateRoute>
              <WalletTopUp />
            </PrivateRoute>
          } />
          
          <Route path="/users" element={
            <PrivateRoute roles={['admin']}>
              <UserList />
            </PrivateRoute>
          } />
          
          <Route path="/profile" element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          } />

            <Route path="*" element={<Navigate to="/rooms" replace />} />
          </Routes>
          </Suspense>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
